<template>
<div class="col-md-12" style="border: 1px solid black">
    <h4 style="margin-top:5px;">Animal Details
       <b-button class="float-right" @click="handleback" variant="success">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>
    
    <hr />
  <div class="row">
    <br />
    <div class="col-12" style="margin-top: 30px">
      <b-card-text>
        <center>
          <img src="../assets/123.jpg" height="250px" /><br />
          <h7><b>Name:cow</b></h7
          ><br />
          <h7><b>Type:</b></h7
          ><br />
          <h7><b>Amount:20000</b></h7
          ><br />
          <h7><b>Tag No:</b></h7
          ><br />
          <h7><b>Daily Milk:</b></h7>
        </center>
      </b-card-text>
      <div class="btn-group col-12">
       <button type="button" class="btn btn-xs btn-success col-6" @click="add_to_cart">
          <b-icon-cart></b-icon-cart> Buy
        </button>
        &nbsp;
        <button type="button" class="btn btn-xs btn-success col-6" @click="add_to_cart">
          <b-icon-cart></b-icon-cart> Cart
        </button>
      </div>
    </div>
  </div><br/>
</div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    handleback(){
      this.$router.go(-1);
    },
    add_to_cart(){
        alert("Added To Cart");
    },
    send_enquiry(){
        alert("Enquiry send to buyer");
    },
  },
};
</script>